const doc = [({"en":({"js":({"competitions_choose_team":({"or_create_your_own_team_and_invite_your_friends":"Or create your own team and invite your friends"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;